import { render, staticRenderFns } from "./TransferRegionCreateOrUpdate.vue?vue&type=template&id=4045a965&"
import script from "./TransferRegionCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TransferRegionCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports